import { format } from "date-fns";

import { formatMoney } from "#app/lib/currency";
import { Card, CardContent } from "#ui/card";

import { CheckCardList, CheckCardListItem } from "./check-card-list";
import type { CheckVm } from "./checks-page.utils";

interface CardCheckSummaryProps extends Omit<
  React.ComponentPropsWithoutRef<"div">,
  "children"
> {
  data: CheckVm;
}

export function CardCheckSummary({ data, ...props }: CardCheckSummaryProps) {
  return (
    <Card {...props} variant="white-border">
      <CardContent className="px-20px py-5px">
        <CheckCardList>
          <CheckCardListItem
            slot0={<strong className="font-semibold">Date</strong>}
            slot1={data.date ? format(data.date, "MM/dd/yyyy") : null}
          />
          <CheckCardListItem
            slot0={<strong className="font-semibold">Check Number</strong>}
            slot1={data.checkNumber}
          />
          <CheckCardListItem
            slot0={<strong className="font-semibold">Check Amount</strong>}
            slot1={formatMoney(data.amount)}
          />
          <CheckCardListItem
            slot0={
              <strong className="font-semibold">
                {data.checkType === "Deposits" ? "Payor" : "Payee"}
              </strong>
            }
            slot1={data.checkType === "Deposits" ? data.payor : data.payee}
          />
          <CheckCardListItem
            slot0={<strong className="font-semibold">Type</strong>}
            slot1={data.checkType}
          />
        </CheckCardList>
      </CardContent>
    </Card>
  );
}
